<template>
    <span>
        <div class="booking-section sdr-box" v-for="(pax, index) in getBookingPassengers(modulo)" v-bind:key="index" v-bind:class="{ spacebetweenpaxes: index !== (getBookingPassengers(modulo).length - 1) }">
            <!-- >>> Pax - Types, Forms -->
            <!-- >>> PaxType, ADT -->
            <template v-if="pax.type ==='ADT'">
                <div class="person-information" style="padding-bottom:20px;">
                    <h2 style="padding-bottom: 15px;" v-if="get_areWeInServicesBookingNoMode === false"><i class="soap-icon-passenger circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_adult[getCurrentLocale] }}) - {{ form_enteryourdata[getCurrentLocale] }}.<span class="pull-right price small" style="font-size: 10px; padding-top: 12px;" v-show="travelsWithInfantNumber(pax.id_pax) !== ''">{{ travelswithinfant[getCurrentLocale] }} {{ travelsWithInfantNumber(pax.id_pax) }} <i class="soap-icon-man-1 circle"></i></span></h2>
                    <h2 style="padding-bottom: 15px;" v-if="get_areWeInServicesBookingNoMode === true"><i class="soap-icon-passenger circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_adult[getCurrentLocale] }})<span class="pull-right price small" style="font-size: 10px; padding-top: 12px;" v-show="travelsWithInfantNumber(pax.id_pax) !== ''">{{ travelswithinfant[getCurrentLocale] }} {{ travelsWithInfantNumber(pax.id_pax) }} <i class="soap-icon-man-1 circle"></i></span></h2>
                    <!-- >>> row: salutation -->
                    <div class="form-group row" style="xmargin-bottom:45px;">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_salutation[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <!-- ADT, SAL, SRVCS -->
                            <div class="selector" v-if="get_areWeInServicesBookingNoMode === false">
                                <select class="full-width" v-bind:id="'inputPax_salutation_' + pax.id_pax"  v-bind:name="'inputPax_salutation_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                    <option v-for="(sal, indexsal) in buildSalutations()" v-bind:value="sal.value" v-bind:key="indexsal">{{ sal.text }}</option>
                                </select>
                            </div>
                            <!-- ADT, SAL, SRVCSBOOKINGNNO -->
                            <div class="selector micha" v-if="get_areWeInServicesBookingNoMode === true">
                                <select class="full-width" v-bind:id="'inputPax_salutation_' + pax.id_pax"  v-bind:name="'inputPax_salutation_' + pax.id_pax" disabled>
                                    <option v-for="(sal, indexsal) in buildSalutations()" v-bind:value="sal.value" v-bind:key="indexsal" :selected="sal.value === get_ServicesBookingnoSearchResults[0].passengers[index].salutation">{{ sal.text }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- <<< row: salutation  -->

                    <!-- >>> row: firstname, lastname -->
                    <!-- ADT, SAL, SRVCS -->
                    <div class="form-group row" v-if="get_areWeInServicesBookingNoMode === false">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_firstname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                value=""
                                placeholder=""
                                v-bind:id="'inputPax_firstName_' + pax.id_pax"
                                v-bind:name="'inputPax_firstName_' + pax.id_pax" />
                        </div>
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_lastname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                value=""
                                placeholder=""
                                v-bind:id="'inputPax_lastName_' + pax.id_pax"
                                v-bind:name="'inputPax_lastName_' + pax.id_pax" />
                        </div>
                    </div>
                    <!-- ADT, SAL, SRVCSBOOKINGNNO -->
                    <div class="form-group row" v-if="get_areWeInServicesBookingNoMode === true">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_firstname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                :value="get_areWeInServicesBookingNoMode === true ? get_ServicesBookingnoSearchResults[0].passengers[index].firstName : ''"
                                placeholder=""
                                v-bind:id="'inputPax_firstName_' + pax.id_pax"
                                v-bind:name="'inputPax_firstName_' + pax.id_pax"
                                :disabled="get_areWeInServicesBookingNoMode === true" />
                        </div>
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_lastname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                :value="get_areWeInServicesBookingNoMode === true ? get_ServicesBookingnoSearchResults[0].passengers[index].lastName : ''"
                                placeholder=""
                                v-bind:id="'inputPax_lastName_' + pax.id_pax"
                                v-bind:name="'inputPax_lastName_' + pax.id_pax"
                                :disabled="get_areWeInServicesBookingNoMode === true" />
                        </div>
                    </div>
                    <!-- <<< row: firstname, lastname -->

                    <!-- >>> row: birthdate -->
                    <div class="form-group row">
                        <div class="col-md-8">
                            <label>{{ form_birthdate[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <!-- ADT, SAL, SRVCS -->
                            <div class="constant-column-5" v-if="get_areWeInServicesBookingNoMode === false">
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateDay_' + pax.id_pax" v-bind:name="'inputPax_BirthdateDay_' + pax.id_pax">
                                        <option v-for="day in 31" v-bind:value="day" v-bind:key="day">{{ day }}</option>
                                    </select>
                                </div>
                                <div class="selector" v-bind:class="{ micha: get_areWeInServicesBookingNoMode === true }">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateMonth_' + pax.id_pax" v-bind:name="'inputPax_BirthdateMonth_' + pax.id_pax">
                                        <option v-for="(month, index) in buildMonths()" v-bind:value="month.value" v-bind:key="index">{{ month.text }}</option>
                                    </select>
                                </div>
                                <div class="selector" v-bind:class="{ micha: get_areWeInServicesBookingNoMode === true }">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateYear_' + pax.id_pax" v-bind:name="'inputPax_BirthdateYear_' + pax.id_pax">
                                        <option v-for="(year, index) in buildYears('ADT')" v-bind:value="year.value" v-bind:key="index">{{ year.text }}</option>
                                    </select>
                                </div>
                            </div>
                            <!-- ADT, SAL, SRVCSBOOKINGNNO -->
                            <div class="constant-column-5" v-if="get_areWeInServicesBookingNoMode === true">
                                <div class="selector micha">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateDay_' + pax.id_pax" v-bind:name="'inputPax_BirthdateDay_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(day, indexd) in 31" v-bind:value="day" v-bind:key="indexd" :selected="day === new Date(get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getDate()">{{ day }}</option>
                                    </select>
                                </div>
                                <div class="selector micha">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateMonth_' + pax.id_pax" v-bind:name="'inputPax_BirthdateMonth_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(month, indexm) in buildMonths()" v-bind:value="month.value" v-bind:key="indexm" :selected="month.value === new Date(get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getMonth() + 1">{{ month.text }}</option>
                                    </select>
                                </div>
                                <div class="selector micha">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateYear_' + pax.id_pax" v-bind:name="'inputPax_BirthdateYear_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(year, indexy) in buildYears('ADT')" v-bind:value="year.value" v-bind:key="indexy" :selected="year.value === new Date(get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getFullYear()">{{ year.text }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< row: birthdate -->
                </div>
            </template>
            <!-- <<< PaxType, ADT -->


            <!-- >>> PaxType, CHD -->
            <template v-if="pax.type ==='CHD'">
                <div class="person-information" style="padding-bottom:20px;">
                    <h2 style="padding-bottom: 15px;"><i class="soap-icon-passenger circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_child[getCurrentLocale] }}) - {{ form_enteryourdata[getCurrentLocale] }}.</h2>
                    <!-- >>> row: gender  -->
                    <div class="form-group row" style="xmargin-bottom:45px;">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_gender[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <!-- ADT, SAL, SRVCS -->
                            <div class="selector" v-if="get_areWeInServicesBookingNoMode === false">
                                <select class="full-width" v-bind:id="'inputPax_gender_' + pax.id_pax"  v-bind:name="'inputPax_gender_' + pax.id_pax">
                                    <option v-for="(gender, indexgen) in buildGenders()" v-bind:value="gender.value" v-bind:key="indexgen">{{ gender.text }}</option>
                                </select>
                            </div>
                            <!-- ADT, SAL, SRVCSBOOKINGNNO -->
                            <div class="selector micha" v-if="get_areWeInServicesBookingNoMode === true">
                                <select class="full-width" v-bind:id="'inputPax_gender_' + pax.id_pax"  v-bind:name="'inputPax_gender_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                    <option v-for="(gender, indexgen) in buildGenders()" v-bind:value="gender.value" v-bind:key="indexgen" :selected="gender.value === get_ServicesBookingnoSearchResults[0].passengers[index].gender.toLowerCase()">{{ gender.text }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- <<< row: gender  -->

                    <!-- >>> row: firstname, lastname -->
                    <!-- ADT, SAL, SRVCS -->
                    <div class="form-group row" v-if="get_areWeInServicesBookingNoMode === false">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_firstname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                value=""
                                placeholder=""
                                v-bind:id="'inputPax_firstName_' + pax.id_pax"
                                v-bind:name="'inputPax_firstName_' + pax.id_pax" />
                        </div>

                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_lastname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                value=""
                                placeholder=""
                                v-bind:id="'inputPax_lastName_' + pax.id_pax"
                                v-bind:name="'inputPax_lastName_' + pax.id_pax" />
                        </div>
                    </div>
                    <!-- ADT, SAL, SRVCSBOOKINGNNO -->
                    <div class="form-group row" v-if="get_areWeInServicesBookingNoMode === true">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_firstname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                :value="get_areWeInServicesBookingNoMode === true ? get_ServicesBookingnoSearchResults[0].passengers[index].firstName : ''"
                                placeholder=""
                                v-bind:id="'inputPax_firstName_' + pax.id_pax"
                                v-bind:name="'inputPax_firstName_' + pax.id_pax"
                                :disabled="get_areWeInServicesBookingNoMode === true" />
                        </div>

                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_lastname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width"
                                :value="get_areWeInServicesBookingNoMode === true ? get_ServicesBookingnoSearchResults[0].passengers[index].lastName : ''"
                                placeholder=""
                                v-bind:id="'inputPax_lastName_' + pax.id_pax"
                                v-bind:name="'inputPax_lastName_' + pax.id_pax"
                                :disabled="get_areWeInServicesBookingNoMode === true" />
                        </div>
                    </div>
                    <!-- <<< row: firstname, lastname -->

                    <!-- >>> row: birthdate -->
                    <div class="form-group row">
                        <div class="col-sm-6 col-md-8">
                            <label>{{ form_birthdate[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <!-- ADT, SAL, SRVCS -->
                            <div class="constant-column-5" v-if="get_areWeInServicesBookingNoMode === false">
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateDay_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateDay_' + pax.id_pax">
                                        <option v-for="day in 31" v-bind:value="day" v-bind:key="day">{{ day}}</option>
                                    </select>
                                </div>
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateMonth_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateMonth_' + pax.id_pax">
                                        <option v-for="(month, index) in buildMonths()" v-bind:value="month.value" v-bind:key="index">{{ month.text }}</option>
                                    </select>
                                </div>
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateYear_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateYear_' + pax.id_pax">
                                        <option v-for="(year, index) in buildYears('CHD')" v-bind:value="year.value" v-bind:key="index">{{ year.text }}</option>
                                    </select>
                                </div>
                            </div>
                            <!-- ADT, SAL, SRVCSBOOKINGNNO -->
                            <div class="constant-column-5" v-if="get_areWeInServicesBookingNoMode === true">
                                <div class="selector micha">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateDay_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateDay_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(day, indexd) in 31" v-bind:value="day" v-bind:key="indexd" :selected="day === new Date(get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getDate()">{{ day}}</option>
                                    </select>
                                </div>
                                <div class="selector micha">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateMonth_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateMonth_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(month, indexm) in buildMonths()" v-bind:value="month.value" v-bind:key="indexm" :selected="month.value === new Date(get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getMonth() + 1">{{ month.text }}</option>
                                    </select>
                                </div>
                                <div class="selector micha">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateYear_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateYear_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(year, indexy) in buildYears('CHD')" v-bind:value="year.value" v-bind:key="indexy" :selected="year.value === new Date(get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getFullYear()">{{ year.text }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< row: birthdate -->
                </div>
            </template>
            <!-- <<< PaxType, CHD -->


            <!-- >>> PaxType, INF -->
            <template v-if="pax.type ==='INF' && modulo === 'booking'">
                <div class="person-information" style="padding-bottom:20px;">
                    <h2 style="padding-bottom: 15px;"><i class="soap-icon-man-1 circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_infant[getCurrentLocale] }}) -  {{ form_enteryourdata[getCurrentLocale] }}.</h2>
                    <!-- >>> row: gender  -->
                    <div class="form-group row" style="xmargin-bottom:45px;">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_gender[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <div class="selector">
                                <select class="full-width" v-bind:id="'inputPax_gender_' + pax.id_pax"  v-bind:name="'inputPax_gender_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                    <option v-for="(gender, index) in buildGenders()" v-bind:value="gender.value" v-bind:key="index">{{ gender.text }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- <<< row: gender  -->

                    <!-- >>> row: firstname, lastname -->
                    <div class="form-group row">
                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_firstname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width" value="" placeholder="" v-bind:id="'inputPax_firstName_' + pax.id_pax"  v-bind:name="'inputPax_firstName_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true" />
                        </div>

                        <div class="col-sm-6 col-md-5">
                            <label>{{ form_lastname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <input type="text" class="input-text full-width" value="" placeholder="" v-bind:id="'inputPax_lastName_' + pax.id_pax"  v-bind:name="'inputPax_lastName_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true" />
                        </div>
                    </div>
                    <!-- <<< row: firstname, lastname -->

                    <!-- >>> row:birthdate -->
                    <div class="form-group row">
                        <div class="col-sm-6 col-md-8">
                            <label>{{ form_birthdate[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                            <div class="constant-column-5">
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateDay_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateDay_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="day in 31" v-bind:value="day" v-bind:key="day">{{ day}}</option>
                                    </select>
                                </div>
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateMonth_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateMonth_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(month, index) in buildMonths()" v-bind:value="month.value" v-bind:key="index">{{ month.text }}</option>
                                    </select>
                                </div>
                                <div class="selector">
                                    <select class="full-width" v-bind:id="'inputPax_BirthdateYear_' + pax.id_pax"  v-bind:name="'inputPax_BirthdateYear_' + pax.id_pax" :disabled="get_areWeInServicesBookingNoMode === true">
                                        <option v-for="(year, index) in buildYears('INF')" v-bind:value="year.value" v-bind:key="index">{{ year.text }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <<< row: birthdate -->
                </div>
            </template>
            <!-- <<< PaxType, INF -->
            <!-- <<< Pax - Types, Forms -->




            <!-- >>> Services for 'Booking' -->
            <template v-if="modulo === 'booking'">
                <span style="padding-top:40px; color: red; font-size:14px;" v-if="pax.type !=='INF' && getBookingDoesAnySrvcsExistAtAll === true">{{ starsaremandatory[getCurrentLocale] }}</span>
                <hr v-if="pax.type !=='INF' && getBookingDoesAnySrvcsExistAtAll === true" style="padding-top:20px;">

                <!-- >>> Pax - Srvcs (own Toggle) -->
                <div class="toggle-container box" v-if="getBookingDoesAnySrvcsExistAtAll === true">
                    <div class="panel style2">
                        <h2 class="panel-title idea-title">
                            <a class="collapsed" v-bind:href="'#maintgg_' + pax.id_pax" data-toggle="collapse" v-if="pax.type !=='INF' && pax.type ==='ADT'" style="padding-bottom: 15px;"><i class="soap-icon-fork circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_adult[getCurrentLocale] }}) - {{ form_addservices[getCurrentLocale] }}.</a>
                            <a class="collapsed" v-bind:href="'#maintgg_' + pax.id_pax" data-toggle="collapse" v-if="pax.type !=='INF' && pax.type ==='CHD'" style="padding-bottom: 15px;"><i class="soap-icon-fork circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_child[getCurrentLocale] }}) - {{ form_addservices[getCurrentLocale] }}.</a>
                        </h2>

                        <div class="panel-collapse collapse" v-bind:id="'maintgg_' + pax.id_pax">
                            <!-- >>> Weve got Seats Srvcs! -->
                            <span v-if="getBookingSrvcsSeatExistOnOut || getBookingSrvcsSeatExistOnRet">
                                <br /><br />

                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:20px; background: "><span class="index" style="background: #dde0e2;"><i class="soap-icon-bottom"></i></span>{{ headline_chooseyourseat[getCurrentLocale] }}:</h3>
                                </div>

                                <p>{{ longseattext[getCurrentLocale] }}</p>
                                <hr style="margin-top: 20px; margin-bottom: 20px;">
                                <div class="image-box style12">
                                    <article class="box" v-bind:class="{ 'has-discount': getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== '' }"> <!-- >>> 'Added' Ribbon -->
                                        <figure style="xpadding-top:9px;">
                                            <a class="hover-effect">
                                                <img src="/res/images/services/seats/seats1.png">
                                                <span class="discount" v-show="getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== ''"><span class="discount-text">{{ added[getCurrentLocale] }}</span></span> <!-- >>> 'Added' Ribbon -->
                                            </a>
                                        </figure>
                                        <div class="details">
                                            <h4 class="box-title" v-show="travelsWithInfantNumber(pax.id_pax) !== ''" style="margin-bottom:0px;">{{ seatpreselection[getCurrentLocale] }}: </h4>
                                            <p v-show="travelsWithInfantNumber(pax.id_pax) !== ''" style="color: red;">{{ seatwithbabytext[getCurrentLocale] }}</p>

                                            <h4 class="box-title" v-show="travelsWithInfantNumber(pax.id_pax) === ''" style="margin-bottom:0px;">{{ seatpreselection[getCurrentLocale] }}: </h4>
                                            <p v-show="travelsWithInfantNumber(pax.id_pax) === ''" style="color: red;">{{ seatwithoutbabytext[getCurrentLocale] }}</p>

                                            <p v-html="seattext[getCurrentLocale]"></p>
                                        </div>
                                        <div class="action">
                                            <span class="price"><small>{{ startingat[getCurrentLocale] }}</small>{{ 12 | rndAmntRUAFWZ }}</span>
                                            <a class="button btn-small green" @click.prevent="onClick_SrvcSeat({ pax: pax })">{{ btn_chooseservices[getCurrentLocale] }}</a>
                                        </div>
                                    </article>
                                    <hr style="margin-top: 20px; margin-bottom: 20px;">
                                </div>
                            </span>
                            <!-- <<< Weve got Seats Srvcs! -->


                            <!-- >>> Weve got other Srvcs but Seats! -->
                            <span v-if="getBookingDoesAnySrvcsExistAtAllWOSeats === true">
                                <br /><br />

                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:30px; background: "><span class="index" style="background: #dde0e2;"><i class="soap-icon-bottom"></i></span>{{ headline_chooseyourservices[getCurrentLocale] }}:</h3>
                                </div>

                                <div class="panel-content">
                                    <!-- >>> VueCmp - 'sdr-services-list', 'Services List' -->
                                    <sdr-services-list v-if="pax.type !=='INF'" v-bind:id_pax="pax.id_pax" :modulo="modulo"></sdr-services-list>
                                    <!-- <<< VueCmp - 'sdr-services-list', 'Services List' -->
                                </div>
                            </span>
                            <!-- <<< Weve got other Srvcs but Seats! -->
                        </div>
                    </div>
                </div>
                <!-- <<< Pax - Srvcs (own Toggle) -->
            </template>
            <!-- <<< Services for 'Booking' -->


            <!-- >>> Services for 'Services' -->
            <template v-if="modulo === 'services'">
                <span style="padding-top:40px; color: red; font-size:14px;" v-if="pax.type !=='INF' && getServicesDoesAnySrvcsExistAtAll === true">{{ starsaremandatory[getCurrentLocale] }}</span>
                <hr v-if="pax.type !=='INF' && getServicesDoesAnySrvcsExistAtAll === true" style="padding-top:20px;">

                <div class="alert alert-help" v-if="pax.type !=='INF' && get_areWeInServicesBookingNoMode === true">
                    <h4>{{ yourearlierservices[getCurrentLocale] }}</h4>

                    <template v-if="get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'outward' }).length > 0">
                        <b>{{ bluebox_outward[getCurrentLocale] }}</b>
                        <span v-for="(paxsrvcs, indexX) in get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'outward' })" v-bind:key="indexX">
                            {{ paxsrvcs.label + ' (' + paxsrvcs.quantity + 'x); '}}
                        </span>
                    </template>
                    <template v-if="get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'outward' }).length === 0">
                        <b>{{ bluebox_outward[getCurrentLocale] }}</b> {{ none[getCurrentLocale] }}
                    </template>

                    <template v-if="get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'return' }).length > 0 && get_ServicesBookingnoHasReturnFlight === true">
                        <br /><br /><b>{{ bluebox_return[getCurrentLocale] }}</b>
                        <span v-for="(paxsrvcs, indexX) in get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'return' })" v-bind:key="indexX">
                            {{ paxsrvcs.label + ' (' + paxsrvcs.quantity + 'x); '}}
                        </span>
                    </template>
                    <template v-if="get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'return' }).length === 0 && get_ServicesBookingnoHasReturnFlight === true">
                        <br /><br /><b>{{ bluebox_return[getCurrentLocale] }}</b> {{ none[getCurrentLocale] }}
                    </template>
                    <span class="close"></span>
                </div>
                <br />

                <!-- >>> Pax - Srvcs (own Toggle) -->
                <div class="toggle-container box" v-if="getServicesDoesAnySrvcsExistAtAll === true">
                    <div class="panel style2">
                        <h2 class="panel-title idea-title">
                            <a class="collapsed" v-bind:href="'#maintgg_' + pax.id_pax" data-toggle="collapse" v-if="pax.type !=='INF' && pax.type ==='ADT'" style="padding-bottom: 15px;"><i class="soap-icon-fork circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_adult[getCurrentLocale] }}) - {{ form_addservices[getCurrentLocale] }}.</a>
                            <a class="collapsed" v-bind:href="'#maintgg_' + pax.id_pax" data-toggle="collapse" v-if="pax.type !=='INF' && pax.type ==='CHD'" style="padding-bottom: 15px;"><i class="soap-icon-fork circle"></i> {{ form_pax[getCurrentLocale] }} {{ pax.index }}: ({{ form_child[getCurrentLocale] }}) - {{ form_addservices[getCurrentLocale] }}.</a>
                        </h2>

                        <div class="panel-collapse collapse" v-bind:id="'maintgg_' + pax.id_pax">
                            <!-- >>> Weve got Seats Srvcs! -->
                            <span v-if="getBookingSrvcsSeatExistOnOut || getBookingSrvcsSeatExistOnRet">
                                <br /><br />

                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:20px; background: "><span class="index" style="background: #dde0e2;"><i class="soap-icon-bottom"></i></span>{{ headline_chooseyourseat[getCurrentLocale] }}:</h3>
                                </div>

                                <p>{{ longseattext[getCurrentLocale] }}</p>
                                <hr style="margin-top: 20px; margin-bottom: 20px;">
                                <div class="image-box style12">
                                    <article class="box" v-bind:class="{ 'has-discount': getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== '' }"> <!-- >>> 'Added' Ribbon -->
                                        <figure style="xpadding-top:9px;">
                                            <a class="hover-effect">
                                                <img src="/res/images/services/seats/seats1.png">
                                                <span class="discount" v-show="getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== ''"><span class="discount-text">{{ added[getCurrentLocale] }}</span></span> <!-- >>> 'Added' Ribbon -->
                                            </a>
                                        </figure>
                                        <div class="details">
                                            <h4 class="box-title" v-show="travelsWithInfantNumber(pax.id_pax) !== ''" style="margin-bottom:0px;">{{ seatpreselection[getCurrentLocale] }}: </h4>
                                            <p v-show="travelsWithInfantNumber(pax.id_pax) !== ''" style="color: red;">{{ seatwithbabytext[getCurrentLocale] }}</p>

                                            <h4 class="box-title" v-show="travelsWithInfantNumber(pax.id_pax) === ''" style="margin-bottom:0px;">{{ seatpreselection[getCurrentLocale] }}: </h4>
                                            <p v-show="travelsWithInfantNumber(pax.id_pax) === ''" style="color: red;">{{ seatwithoutbabytext[getCurrentLocale] }}</p>

                                            <p v-html="seattext[getCurrentLocale]"></p>
                                        </div>
                                        <div class="action">
                                            <span class="price"><small>{{ startingat[getCurrentLocale] }}</small>{{ 12 | rndAmntRUAFWZ }}</span>
                                            <a class="button btn-small green" @click.prevent="onClick_SrvcSeat({ pax: pax })">{{ btn_chooseservices[getCurrentLocale] }}</a>
                                        </div>
                                    </article>
                                    <hr style="margin-top: 20px; margin-bottom: 20px;">
                                </div>
                            </span>
                            <!-- <<< Weve got Seats Srvcs! -->


                            <!-- >>> Weve got other Srvcs but Seats! -->
                            <span v-if="getServicesDoesAnySrvcsExistAtAllWOSeats === true">
                                <br /><br />

                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:30px; background: "><span class="index" style="background: #dde0e2;"><i class="soap-icon-bottom"></i></span>{{ headline_chooseyourservices[getCurrentLocale] }}:</h3>
                                </div>

                                <div class="panel-content">
                                    <!-- >>> VueCmp - 'sdr-services-list', 'Services List' -->
                                    <sdr-services-list v-if="pax.type !=='INF'" v-bind:id_pax="pax.id_pax" :modulo="modulo"></sdr-services-list>
                                    <!-- <<< VueCmp - 'sdr-services-list', 'Services List' -->
                                </div>
                            </span>
                            <!-- <<< Weve got other Srvcs but Seats! -->
                        </div>
                    </div>
                </div>
                <!-- <<< Pax - Srvcs (own Toggle) -->
            </template>
            <!-- <<< Services for 'Services' -->
        </div>





        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="seatmap-modal"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="200"
                :min-height="200"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="600px"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="seatmap-modal-content">
                    <section id="content" style="padding-top:10px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:10px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ modal_headline_seatmaps[getCurrentLocale] }}</h3>
                                </div>

                                <!-- >>> Tabs -->
                                <div class="tab-container style1" style="background-color: white;">
                                    <!-- >>> TabHeader:  -->
                                    <ul class="tabs full-width">
                                        <li v-if="getBookingSrvcsSeatExistOnOut === true" v-bind:class="{ active: getBookingSrvcsSeatExistOnOut === true }">
                                            <a href="#outwardseats" data-toggle="tab">{{ modal_tabheadline_seatforout[getCurrentLocale] }}</a>
                                        </li>
                                        <li v-if="getBookingSrvcsSeatExistOnRet === true" v-bind:class="{ active: getBookingSrvcsSeatExistOnOut === false && getBookingSrvcsSeatExistOnRet === true }">
                                            <a href="#returnseats" data-toggle="tab">{{ modal_tabheadline_seatforret[getCurrentLocale] }}</a>
                                        </li>
                                    </ul>
                                    <!-- <<< TabHeader:  -->


                                    <!-- >>> TabContent: Out/Ret Results -->
                                    <div class="tab-content">
                                        <!-- >>> Tab: 'outwardseats' -->
                                        <div v-if="getBookingSrvcsSeatExistOnOut === true" id="outwardseats" class="tab-pane fade" v-bind:class="{ in: getBookingSrvcsSeatExistOnOut === true, active: getBookingSrvcsSeatExistOnOut === true }">
                                            <!-- >>> VueCmp - 'sdr-seatdetails', 'Seat Details', Outward -->
                                            <sdr-seatdetails flightdirection="outward" v-bind:pax="seatmapdata.pax" :key="seatComponentKeyOutward"></sdr-seatdetails>
                                            <!-- <<< VueCmp - 'sdr-seatdetails', 'Seat Details', Outward -->
                                        </div>
                                        <!-- <<< Tab: 'outwardseats' -->


                                        <!-- >>> Tab: 'returnseats' -->
                                        <div v-if="getBookingSrvcsSeatExistOnRet === true" id="returnseats" class="tab-pane fade" v-bind:class="{ in: getBookingSrvcsSeatExistOnRet === true && getBookingSrvcsSeatExistOnOut === false, active: getBookingSrvcsSeatExistOnRet === true && getBookingSrvcsSeatExistOnOut === false }">
                                            <!-- >>> VueCmp - 'sdr-seatdetails', 'Seat Details', Outward -->
                                            <sdr-seatdetails flightdirection="return" v-bind:pax="seatmapdata.pax" :key="seatComponentKeyReturn"></sdr-seatdetails>
                                            <!-- <<< VueCmp - 'sdr-seatdetails', 'Seat Details', Outward -->
                                        </div>
                                        <!-- <<< Tab: 'returnseats' -->
                                    </div>
                                    <!-- <<< TabContent: Out/Ret Results -->


                                    <!-- >>> Close Modal Button -->
                                    <a class="button btn-large icon-check uppercase full-width sundair" style="margin-top: 15px;" @click.prevent="onClick_CloseModal()">{{ close[getCurrentLocale] }}</a><br />
                                    <!-- <<< Close Modal Button -->
                                </div>
                                <!-- <<< Tabs -->
                            </div>
                        </div>
                    </section>
                </div>
        </modal>
    </span>
</template>

<script>
    import Services from '../../booking/passengers/services/Services.vue';
    import SeatDetails from '../../booking/passengers/services/SeatDetails.vue';

    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import axios from 'axios';
    import moment from 'moment';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-services-list': Services,
            'sdr-seatdetails': SeatDetails,

        }, // eo components
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                seatComponentKeyOutward : 0,
                seatComponentKeyReturn : 0,
                // ------------------------------------------------------------
                starsaremandatory: {
                    en: 'Fields marked with * are required.',
                    de: 'Mit * gekennzeichnete Felder sind Pflichtfelder.'
                },
                form_pax: {
                    en: 'Passenger',
                    de: 'Passagier',
                },
                form_adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                form_child: {
                    en: 'Child',
                    de: 'Kind',
                },
                form_infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                form_salutation: {
                    en: 'Salutation',
                    de: 'Anrede',
                },
                form_gender: {
                    en: 'Gender',
                    de: 'Geschlecht',
                },
                form_firstname : {
                    en: 'First name',
                    de: 'Vorname',
                },
                form_lastname : {
                    en: 'Last name',
                    de: 'Nachname',
                },
                form_birthdate : {
                    en: 'Date of Birth',
                    de: 'Geburtsdatum',
                },
                form_srvcs_headline : {
                    en: 'Here you can book services for Passenger',
                    de: 'Hier Services buchen für Passagier',
                },
                form_enteryourdata : {
                    en: 'Enter data here',
                    de: 'Hier Daten eingeben',
                },
                form_addservices: {
                    en: 'Add Services here',
                    de: 'Hier Services hinzubuchen',
                },
                form_mr: {
                    en: 'Mr.',
                    de: 'Herr',
                },
                form_mrs: {
                    en: 'Mrs.',
                    de: 'Frau',
                },
               form_male: {
                    en: 'Male',
                    de: 'Männlich',
                },
               form_female: {
                    en: 'Female',
                    de: 'Weiblich',
                },
                january: {
                    en: 'January',
                    de: 'Januar',
                },
                february: {
                    en: 'February',
                    de: 'Februar',
                },
                march: {
                    en: 'March',
                    de: 'März',
                },
                april: {
                    en: 'April',
                    de: 'April',
                },
                may: {
                    en: 'May',
                    de: 'Mai',
                },
                june: {
                    en: 'June',
                    de: 'Juni',
                },
                july: {
                    en: 'July',
                    de: 'Juli',
                },
                august: {
                    en: 'August',
                    de: 'August',
                },
                september: {
                    en: 'September',
                    de: 'September',
                },
                october: {
                    en: 'October',
                    de: 'Oktober',
                },
                november: {
                    en: 'November',
                    de: 'November',
                },
                december: {
                    en: 'December',
                    de: 'Dezember',
                },
                travelswithinfant : {
                    en: 'travels with infant',
                    de: 'reist mit kleinkind',
                },
                btn_addservices: {
                    en: 'ADD SERVICE',
                    de: 'HINZUFÜGEN',
                },
                btn_chooseservices: {
                    en: 'CHOOSE SERVICE',
                    de: 'AUSWÄHLEN',
                },
                startingat: {
                    en: 'starting at',
                    de: 'ab',
                },
                longseattext: {
                    en: 'Would you like a window seat or more comfort? Select your seats online in advance with our easy-to-use seat map. When booking on https://euaircharter.com, you can select and change your seat up to 48 hours before departure.',
                    de: 'Möchten Sie einen Fensterplatz oder mehr Komfort? Wählen Sie Ihre Plätze online im Voraus mit unserer einfach zu bedienenden Sitzkarte aus. Bei der Buchung auf https://euaircharter.com können Sie bis 48 Stunden vor Abflug Ihren Sitzplatz wählen und wechseln.',
                },
                seattext: {
                    en: 'Sit next to your friends and family. Or choose a seat directly at the window. Reserve your desired seat!',
                    de: 'Setzen Sie sich neben Ihre Freunde und Familie. Oder wählen Sie einen Platz direkt am Fenster. Reservieren Sie sich Ihren Wunschsitzplatz!',
                },
                seatwithbabytext: {
                    en: '(Note: For passengers travelling with a baby (without their own seat).)',
                    de: '(Hinweis: Für Fluggäste, welche mit einem Baby (ohne eigenem Sitzplatz) reisen.)',
                },
                seatwithoutbabytext: {
                    en: '(Note: For passengers travelling without a baby.)',
                    de: '(Hinweis: Für Fluggäste, welche ohne Baby reisen.)',
                },
                seatpreselection: {
                    en: 'Seat pre-selection',
                    de: 'Sitzplatz Vorauswahl',
                },
                headline_chooseyourseat: {
                    en: 'Choose your seat',
                    de: 'Wählen Sie sich Ihren Sitzplatz aus',
                },
                headline_chooseyourservices: {
                    en: 'Select your additional services',
                    de: 'Wählen Sie sich Ihre zusätzlichen Services aus',
                },
                // >>> --------------------------
                modal_headline_seatmaps: {
                    en: 'Seating plans for Outward and Return Flights',
                    de: 'Sitzpläne für Hin- und Rückflug',
                },
                modal_tabheadline_seatforout: {
                    en: 'seat for the outward flight',
                    de: 'Sitz für den Hinflug',
                },
                modal_tabheadline_seatforret: {
                    en: 'seat for the return flight',
                    de: 'Sitz für den Rückflug',
                },
                // >>> --------------------------
                wanneaddoutward: {
                    en: 'Reserve seat outbound flight?',
                    de: 'Sitz Hinflug reservieren?',
                },
                wanneaddreturn: {
                    en: 'Reserve seat return flight?',
                    de: 'Sitz Rückflug reservieren?',
                },
                reservetext: {
                    en: 'You want to reserve the following seat',
                    de: 'Sie wollen folgenden Sitz reservieren: '
                },
                alertno: {
                    en: 'No',
                    de: 'Nein',
                },
                alertyes: {
                    en: 'Yes',
                    de: 'Ja',
                },
                alerticonfirm: {
                    en: 'I confirm',
                    de: 'Ich bestätige',
                },
                alertirefuse: {
                    en: 'I refuse',
                    de: 'Ich lehne ab',
                },
                confirmplease: {
                    en: 'Bitte bestätigen',
                    de: 'Bitte bestätigen',
                },
                added: {
                    en: 'Added to Cart',
                    de: 'Hinzugefügt',
                },
                close: {
                    en: 'Close the seat map',
                    de: 'Sitzplan schliessen',
                },
                // >>> --------------------------
                bluebox_outward: {
                    en: 'Services outward flight:',
                    de: 'Services Hinflug:',
                },
                bluebox_return: {
                    en: 'Services return flight:',
                    de: 'Services Rückflug:',
                },
                none: {
                    en: 'None yet.',
                    de: 'Noch keine.',
                },
                yourearlierservices: {
                    en: 'Your services from a previous booking:',
                    de: 'Ihre Services aus einer früheren Buchung:'
                },
                // >>> --------------------------
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // ------------------------------
                proceed: {
                    en: 'PROCEED TO PAYMENT INFORMATION',
                    de: 'WEITER ZU ZAHLUNGSDETAILS',
                },
                // currentLocale: 'de',
                // >>> -------------------------- 'Form / Model / Vuelidate'
                inputPax_firstName_1: '',

                // >>> -------------------------- Data for Seats Modal
                seatmapdata: {}
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            // >>> firstname --------------------
            inputPax_firstName_1: {
                required: required,
            },

        }, // eo validations
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_areWeInServicesBookingNoMode',
                // >>> --------------------------
                'getBookingPassengers',
                'getBookingUsersSearchData',
                'getBookingSrvcsSeatExistOnOut',
                'getBookingSrvcsSeatExistOnRet',
                'getBookingDoesAnySrvcsExistAtAll', // we have any srvcs on flight?
                'getBookingDoesAnySrvcsExistAtAllWOSeats', // Srvcs wo. Seats
                'getBookingCartIsSeatAlreadyReserved',
                'getBookingCartHasPaxAlreadyReservedASeat',
                'getBookingSeatReservationLockingCodeResults',
                'getBookingFlightIdSelectedOutward',
                'getBookingFlightIdSelectedReturn',
                'getBookingSeatPrice',
                'getBookingSeatRemark', // get: seattype has remark?
                // >>> --------------------------
                'getServicesDoesAnySrvcsExistAtAll', // we have any srvcs on flight? (same for 'Services')
                'getServicesDoesAnySrvcsExistAtAllWOSeats', // Srvcs wo. Seats (same for 'Services')
                'get_ServicesBookingnoSearchResults',
                'get_ServicesBookingnoServicesPerPax',
                'get_ServicesBookingnoHasReturnFlight',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoforcererender' ('setLock done').
        * Note: Catch Event 'lockafterwards' ('some new lock after unlock').
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> booking/passengers/Passenger.vue >>> created');
            eventBus.$on('readytoforcererender', this.onEmit_ReadyToForceRerender);
            eventBus.$on('lockafterwards', this.onEmit_LockAfterWards);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Select Fields.
        * Note:
        *
        */
        mounted: function() {

            var me = this;


            me.$toc('>>> booking/passengers/Passenger.vue >>> mounted');
            me.$selectInits(this.modulo);

        },  // eof mounted()
        /* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc: Add Listeners to Seatmap after rerendering.
        * Note:
        *
        */
        updated: function() {

            // console.log('Passenger Lifecyclehook :updated()');
            this.$nextTick(function () {
                if (this.seatComponentKeyOutward !== 0 || this.seatComponentKeyReturn !== 0 ) {
                    // console.log('rerendered!!! addddd listeners noooowwwwwww?');
                    this.addListeners_Seatmap(); // remove before?
                }
            });

        }, // eof updated()
        /* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> booking/passengers/Passenger.vue >>> beforeDestroy');
            eventBus.$off('readytoforcererender', this.onEmit_ReadyToForceRerender);
            eventBus.$off('lockafterwards', this.onEmit_LockAfterWards);

        }, // eo function beforeDestroy()
        /* >>> *************************************************************** /  /* LifeCycles */



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setBookingUpdateCartWithSeat', // add: Seat to Cart
                'actn_setBookingUpdateCartViaDeleteSeat', // delete: Seat from Cart
                'actn_call_lockSeat', // call:
                'actn_call_unlockSeat' // call:
            ]),


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (PUT)
            *
            * Desc: Lock Seat via Lockingcode + Seatno. (Attention: Method:PUT)
            * Note: va[0]->'seatName',va[1]->'code',va[2]->'availlabs',
            * Note: va[3]->'type',va[4]->'id_pax',va[5]->'gp_Kop'
            * Note:
            * Note: New: Axios Call is here managed in VUEX.
            * TODO: is 'infantOnLap' wrong?
            *
            * @param {string} cellId
            * @return
            */
            call_lockSeat: function (cellId) {

                var me = this,
                    va = cellId.split("_"),
                    seatno = va[0],
                    seatCode = va[1],
                    type = va[3],
                    id_pax = va[4],
                    infantOnLap = va[4] === 'AdultWithInfant' ? true : false, // wrong ???
                    owf_id = this.getBookingFlightIdSelectedOutward,
                    rtf_id = this.getBookingFlightIdSelectedReturn,
                    price = this.getBookingSeatPrice({ seatCode: seatCode, type: type }),
                    lockingCodes = {},
                    lockingcode = '',
                    newCart_Item = {},
                    payload = {};


                me.$toc('>>> booking/passengers/Passenger.vue >>> call_lockSeat');
                // >>> -------------------------------- Locking Codes
                lockingCodes = this.getBookingSeatReservationLockingCodeResults;
                if (type === 'outward') {
                    lockingcode = lockingCodes.outward.response.seatReservationLockingCode;
                }
                if (type === 'return') {
                    lockingcode = lockingCodes.return.response.seatReservationLockingCode;
                }


                // >>> -------------------------------- New Cart Item
                newCart_Item = {
                    id_pax: id_pax,
                    code: "SEAT",
                    comment: cellId,
                    id_flight: type === 'outward' ? parseInt(owf_id, 10) : parseInt(rtf_id, 10) ,
                    infantOnLap: infantOnLap,
                    lockingcode: lockingcode,
                    quantity: 1,
                    seatno: seatno,
                    tktClass: 'Y',
                    type: type,
                    price: price
                };


                // >>> -------------------------------- Send Ajax Request
                payload = {
                    newCart_Item: newCart_Item
                };
                this.actn_call_lockSeat(newCart_Item);

            }, // eof call_lockSeat()

            /*******************************************************************
            * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (DELETE)
            *
            * Desc: UNLock Seat via Lockingcode + Seatno.
            * Note: New: Axios Call is here managed in VUEX.
            *
            * @param {string} cellId
            * @param {int} id_pax
            * @param {string} type ('out', 'ret')
            * @param {string} seatno
            * @param {bool} lockAfterwards (Should i lock afterwards?)
            */
            call_unlockSeat: function (cellId, id_pax, type, seatno, lockAfterwards) {

                var me = this,
                    lockingCodes = {},
                    lockingcode = '',
                    hdrs = '',
                    payload = {};


                me.$toc('>>> booking/passengers/Passenger.vue >>> call_unlockSeat');
                // >>> -------------------------------- Locking Codes
                lockingCodes = this.getBookingSeatReservationLockingCodeResults;
                if (type === 'outward') {
                    lockingcode = lockingCodes.outward.response.seatReservationLockingCode;
                }
                if (type === 'return') {
                    lockingcode = lockingCodes.return.response.seatReservationLockingCode;
                }


                // >>> -------------------------------- Send Ajax Request
                payload = {
                    lockAfterwards: lockAfterwards,
                    id_pax: id_pax,
                    type: type,
                    lockingcode: lockingcode,
                    seatno: seatno,
                    cellId: cellId,
                };
                this.actn_call_unlockSeat(payload);

            }, // eof call_unlockSeat()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_SrvcSeat()
            *
            * Desc: Click on Button "Add Seat".
            * Note:
            *
            * @param
            * @return
            */
            onClick_SrvcSeat: function(pax) {

                var me = this,
                    data = {};


                me.$toc('>>> booking/passengers/Passenger.vue >>> onClick_SrvcSeat');
                data.pax = pax; // Add Pax ... more?

                // >>> Render Modal -------------------------------------------
                me.$modal.show('seatmap-modal', { data: data });

            }, // eof onClick_SrvcSeat()


            /*******************************************************************
            * Event Listener:click
            *
            * Desc: Click Seat 1.
            * Note:
            *
            * @param {String} value (Clicked Seat)
            * @param {String} direction ('outward', 'return')
            */
            onItemtap_SeatCell: function(value, direction) {

                var me = this,
                    seat = value.target.dataset.target.split('_');


                me.$toc('>>> booking/passengers/Passenger.vue >>> onItemtap_SeatCell');
                this.$modal.show('dialog', {
                    name: 'dialog',
                    title: direction === 'outward' ? me.wanneaddoutward[me.getCurrentLocale] : me.wanneaddreturn[me.getCurrentLocale],
                    text: me.reservetext[me.getCurrentLocale] + '<b>' + seat[0] + ' (' + seat[1] + ')</b><br /><br />',
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {
                                me.$modal.hide('dialog');
                                me.onItemtap_SeatCell_2(value);
                            }
                        },
                    ]
                });

            }, // eof onItemtap_SeatCell()

            /*******************************************************************
            * Event Listener:click
            *
            * Desc: Click Seat 2.
            * Note:
            *
            * @param {String} value (Clicked Seat)
            * @param {String} direction ('outward', 'return')
            */
            onItemtap_SeatCell_2: function(value) {

                var me = this,
                    va = [],
                    type = '',
                    id_pax = '',
                    kop = '',
                    clickAllowed = '', // Is available?
                    remark = null,
                    element = null,
                    cellId = value.target.dataset.target;


                me.$toc('>>> booking/passengers/Passenger.vue >>> onItemtap_SeatCell_2');
                // >>> A 'cellId' at all? --------------------------------------
                if (cellId !== 'no' && cellId !== '') {

                    va = cellId.split("_");  // va[0]->'seatName',va[1]->'code',va[2]->'availlabs',va[3]->'type',va[4]->'id_pax',va[5]->'gp_Kop'
                    type = va[3]; // 'outward', 'return'

                    // >>> Reserved already? -----------------------------------
                    if (me.getBookingCartIsSeatAlreadyReserved({ seatName: va[0], type: type }) === '') {

                        id_pax = va[4];
                        type = va[3];
                        kop = va[5];
                        clickAllowed = va[2][0];

                        // >>> Available at all? -------------------------------
                        if (clickAllowed !== 0) {
                            switch (kop) {
                            case "AdultWithoutInfant":
                                clickAllowed = va[2][3];
                                break;
                            case "AdultWithInfant":
                                clickAllowed = va[2][2];
                                break;
                            case "Child":
                                clickAllowed = va[2][1];
                                break;
                            case "Nobody":
                                clickAllowed = 0;
                                break;
                            default:
                                break;
                            }
                        }

                        // >>> Allowed for Kop? Then Check for Remark! ---------
                        if (clickAllowed === '1') {
                            remark = this.getBookingSeatRemark({ seatCode: va[1], type: type });
                            remark = remark.replace(/(?:\r\n|\r|\n)/g, '<br>');
                            if (remark) { // 'Remark':Yes ...
                                this.$modal.show('dialog', {
                                    title: me.confirmplease[me.getCurrentLocale],
                                    text: remark,
                                    buttons: [
                                        {
                                            title: me.alertirefuse[me.getCurrentLocale]
                                        },
                                        {
                                            title: me.alerticonfirm[me.getCurrentLocale],
                                            default: true,
                                            handler: () => {
                                                me.$modal.hide('dialog');
                                                element = document.getElementById(cellId);
                                                element.classList.add("seatmapLoading"); // Note: element.classList.remove("seatmapLoading")
                                                me.onTap_BtnSeatMsgBox_Yes(id_pax, type, cellId);
                                            }
                                        },
                                    ]
                                });
                            }

                            if (!remark) { // 'Remark':No ...
                                element = document.getElementById(cellId);
                                element.classList.add("seatmapLoading"); // Note: element.classList.remove("seatmapLoading")
                                me.onTap_BtnSeatMsgBox_Yes(id_pax, type, cellId);
                            }
                        }
                    }
                    // <<< Reserved already? -----------------------------------

                }
                // <<< A 'cellId' at all? --------------------------------------

            }, // eof onItemtap_SeatCell_2()


            /*******************************************************************
            * onTap_BtnSeatMsgBox_Yes
            *
            * Desc:
            * Note: Method Name is misleading. Only for reasons of equality.
            *
            * @param {string} id_pax
            * @param {string} type ('out', 'ret')
            * @param {String} cellId (Infos about Cell)
            */
            onTap_BtnSeatMsgBox_Yes: function (id_pax, type, cellId) {

                var me = this,
                    paxrsrvdAlready = '';


                me.$toc('>>> booking/passengers/Passenger.vue >>> onTap_BtnSeatMsgBox_Yes');
                paxrsrvdAlready = me.getBookingCartHasPaxAlreadyReservedASeat({ id_pax: id_pax, type: type }); // Returns 'seatno'
                if (paxrsrvdAlready !== '') {
                    me.call_unlockSeat(cellId, id_pax, type, paxrsrvdAlready, true);
                } else {
                    me.call_lockSeat(cellId);
                }

            }, // eof onTap_BtnSeatMsgBox_Yes()


            /*******************************************************************
            * onClick_CloseModal()
            *
            * Desc:
            * Note: Method Name is misleading. Only for reasons of equality.
            *
            */
            onClick_CloseModal: function() {

                var me = this;


                me.$toc('>>> booking/passengers/Passenger.vue >>> onClick_CloseModal');
                me.$modal.hide('seatmap-modal');

            }, // eo function onClick_CloseModal()



            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToForceRerender()
            *
            * Desc: Handle 'Ready to forece Rerender' after lockSeat Call.
            * Note:
            *
            */
            onEmit_ReadyToForceRerender: function(type) {

                let me = this;


                me.$toc('>>> booking/passengers/Passenger.vue >>> onEmit_ReadyToForceRerender');
                me.forceRerender(type.type);

            }, // eo function onEmit_ReadyToForceRerender()

            /*******************************************************************
            * onEmit_ReadyToForceRerender()
            *
            * Desc: Handle 'lockAfterwards' from 'actn_call_unlockSeat' Call.
            * Note:
            *
            */
            onEmit_LockAfterWards: function(cellId) {

                let me = this;


                me.$toc('>>> booking/passengers/Passenger.vue >>> onEmit_LockAfterWards');
                this.call_lockSeat(cellId);

            }, // eo function onEmit_LockAfterWards()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * forceRerender()
            *
            * Desc: Simply change the Components :key to force rerendering.
            * Note: Triggered via eventBus.
            *
            */
            forceRerender: function(direction) {

                var me = this;


                me.$toc('>>> booking/passengers/Passenger.vue >>> forceRerender');
                if (direction === 'outward') {
                    this.seatComponentKeyOutward += 1;
                }

                if (direction === 'return') {
                    this.seatComponentKeyReturn += 1;
                }

            }, // eo function forceRerender()


            /*******************************************************************
            * addListeners_Seatmap()
            *
            * Desc: Add Click Listeners to Seatmap(s).
            * Note:
            */
            addListeners_Seatmap: function() {

                var me = this,
                    outButts = [],
                    retButts = [];



                me.$toc('>>> booking/passengers/Passenger.vue >>> addListeners_Seatmap');
                outButts = document.getElementsByClassName("confirmation-callback-cells-outward");
                for (var i = 0; i < outButts.length; i++) {
                    outButts[i].addEventListener("click", function(e) {
                        e.preventDefault(); // The 'Link'
                        me.onItemtap_SeatCell(e, 'outward');
                    });
                }

                retButts = document.getElementsByClassName("confirmation-callback-cells-return");
                for (var i = 0; i < retButts.length; i++) {
                    retButts[i].addEventListener("click", function(e) {
                        e.preventDefault(); // The 'Link'
                        me.onItemtap_SeatCell(e, 'return');
                    });
                }

            }, // eo function addListeners_Seatmap()

            /*******************************************************************
            * removeListeners_Seatmap()
            *
            * Desc: Remove Click Listeners from Seatmap(s).
            * Note:
            *
            */
            removeListeners_Seatmap: function() {

                var me = this,
                    outButts = [],
                    retButts = [];


                me.$toc('>>> booking/passengers/Passenger.vue >>> removeListeners_Seatmap');
                outButts = document.getElementsByClassName("confirmation-callback-cells-outward");
                for (var i = 0; i < outButts.length; i++) {
                    outButts[i].removeEventListener("click",{});
                }

                retButts = document.getElementsByClassName("confirmation-callback-cells-return");
                for (var i = 0; i < retButts.length; i++) {
                    retButts[i].removeEventListener("click",{});
                }

            }, // eof removeListeners_Seatmap()


            /*******************************************************************
            * buildSalutations()
            *
            * Desc: Build Array of 'Salutations' (trnsltd).
            *
            * @param
            * @return {Array}
            */
            buildSalutations: function() {

                var me = this,
                    salutations = [];


                me.$toc('>>> booking/passengers/Passenger.vue >>> buildSalutations');
                salutations.push(
                    { text: me.form_mr[me.getCurrentLocale], value: 'MR' },
                    { text: me.form_mrs[me.getCurrentLocale], value: 'MRS' },
                );

                return salutations;

            }, // eof buildSalutations()

            /*******************************************************************
            * buildGenders()
            *
            * Desc: Build Array of 'Genders' (trnsltd).
            *
            * @param
            * @return {Array}
            */
            buildGenders: function() {

                var me = this,
                    genders = [];


                me.$toc('>>> booking/passengers/Passenger.vue >>> buildGenders');
                genders.push(
                    { text: me.form_male[me.getCurrentLocale], value: 'm' },
                    { text: me.form_female[me.getCurrentLocale], value: 'f' },
                );

                return genders;

            }, // eof buildGenders()

            /*******************************************************************
            * buildMonths()
            *
            * Desc: Build Array of 'Months' (trnsltd).
            *
            * @param
            * @return {Array}
            */
            buildMonths: function() {

                var me = this,
                    months = [];


                me.$toc('>>> booking/passengers/Passenger.vue >>> buildMonths');
                months.push(
                    { text: me.january[me.getCurrentLocale], value: 1 },
                    { text: me.february[me.getCurrentLocale], value: 2 },
                    { text: me.march[me.getCurrentLocale], value: 3 },
                    { text: me.april[me.getCurrentLocale], value: 4 },
                    { text: me.may[me.getCurrentLocale], value: 5 },
                    { text: me.june[me.getCurrentLocale], value: 6 },
                    { text: me.july[me.getCurrentLocale], value: 7 },
                    { text: me.august[me.getCurrentLocale], value: 8 },
                    { text: me.september[me.getCurrentLocale], value: 9 },
                    { text: me.october[me.getCurrentLocale], value: 10 },
                    { text: me.november[me.getCurrentLocale], value: 11 },
                    { text: me.december[me.getCurrentLocale], value: 12 },
                );

                return months;

            }, // eof buildMonths()

            /*******************************************************************
            * buildYears()
            *
            * Desc: Build Array of 'Years'.
            * Note: Pays Attention to ADT, CHD, INF Types.
            *
            * @param {String} type ('ADT, 'CHD', 'INF')
            * @return {Array}
            */
            buildYears: function(type) {

                let me = this,
                    maxChildAge = 12, // ToDo: Should be a global Prop
                    maxInfantAge = 2, // ToDo: Should be a global Prop
                    startYearAdult = moment().subtract(maxChildAge, 'years').add(1, 'years').format('YYYY'),
                    startYearChild  = moment().subtract(maxInfantAge, 'years').format('YYYY'),
                    endYearChild = moment().subtract(maxChildAge, 'years').format('YYYY'),
                    startYearInf = moment().format('YYYY'),
                    endYearInf = moment().subtract(maxInfantAge, 'years').format('YYYY'),
                    iyear = 0,
                    years = [];


                me.$toc('>>> booking/passengers/Passenger.vue >>> buildYears');
                if (type === 'ADT') {
                    for (iyear = startYearAdult; iyear >= 1905; iyear -= 1) {
                        years.push(
                            { text:String(iyear), value: iyear },
                        );
                    }
                }

                if (type === 'CHD') {
                    for (iyear = startYearChild; iyear >= endYearChild; iyear -= 1) {
                        years.push(
                            { text:String(iyear), value: iyear },
                        );
                    }
                }

                if (type === 'INF') {
                    for (iyear = startYearInf; iyear >= endYearInf; iyear -= 1) {
                        years.push(
                            { text:String(iyear), value: iyear },
                        );
                    }
                }

                return years;

            }, // eof buildYears()


            /*******************************************************************
            * travelsWithInfantNumber()
            *
            * Desc:
            * Note:
            *
            * @param {Int} id_pax
            * @return {Int} travelsWithInfantNumber
            */
            travelsWithInfantNumber: function(id_pax) {

                let me = this,
                    travelsWithInfantNumber = '',
                    countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                    countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                    countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                    countADTCHD = countADT + countCHD,
                    countADTCHDINF = countADTCHD + countINF;


                // me.$toc('>>> booking/passengers/Passenger.vue >>> travelsWithInfantNumber');
                // >>> ---------------------------------------------------------
                if (countINF === 0) {
                    travelsWithInfantNumber = '';
                }

                // >>> ---------------------------------------------------------
                if (countINF !== 0) {
                    // >>> Step 1: Catch every Pax Data (INF) ------------------
                    for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {
                        // >>> Arrange adults to a baby ------------------------
                        if (i === parseFloat(id_pax) + parseFloat(countADTCHD)) {
                            // console.log('my adt is : ' + id_pax);
                            // console.log('its inf is : ' + i);
                            travelsWithInfantNumber = i;
                        }
                    }
                }


                return travelsWithInfantNumber;

            }, // eof travelsWithInfant()





            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen: function(event) {

                this.seatmapdata = event.params.data;

            }, // eo function beforeOpen()

            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc:
            * Note:
            *
            */
            beforeClose: function(e) {

                this.seatmapdata = {};

            }, // eo function beforeClose()

            /*******************************************************************
            * Modal - Events - opened
            *
            * Desc:
            * Note: Add Listeners to SeatMaps single Seats.
            *
            */
            opened: function(e) {

                var me = this;


                this.addListeners_Seatmap();

            }, // eo function opened()

            /*******************************************************************
            * Modal - Events - closed
            *
            * Desc:
            * Note: Remove all Listener from SeatMaps single Seats.
            *
            */
            closed: function(e) {

                var me = this;


                this.removeListeners_Seatmap();

            } // eo function closed()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style>
    .selector.micha span.custom-select-services {
        opacity: .6 !important;
        color: green;
    }
</style>

<style scoped>
    /* .selector select {
        opacity: 1;
    } */

    .likeh2 {
        font-size: 1.6667em;
        line-height: 1.25em;
    }
    .toggle-container .panel.style2 .panel-title > a {
        padding-left: 0px;
        padding-right: 0px;
    }
    .toggle-container .panel.style2 .panel-title > a.collapsed:after {
        background: #827e7f;
    }
    .toggle-container .panel.style2 .panel-title > a:after {
        right: 0px;
        bottom: 17px;
    }
    .toggle-container .panel.style2 .panel-title > a.collapsed:hover {
        color: #827e7f;
    }
    hr {
        margin-bottom: 0px;
    }
    .toggle-container .panel.style2 .panel-title > a {
        color: #303D50;
    }
    [class^="soap-icon"].circle, [class*=" soap-icon"].circle, .glyphicon.circle {
        background: #da1615;
        color: #fff;
    }
    .spacebetweenpaxes {
        margin-bottom: 59px;
    }



    input:focus {
        outline: none;
    }
    input.input-text:focus, textarea:focus, .selector select:focus + .custom-select {
        outline: none;
        border: 1px solid #d3e4f7;
        box-shadow: 0 0 8px #d3e4f7;
    }

    input.input-text.invalid {
        border: 1px solid red;
        background-color: #fdecf8;
    }
    .selector select.invalid {
        border: 1px solid red;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }


    /* Modal */
    .seatmap-modal-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
    }
    .v--modal-overlay[data-modal="seatmap-modal"] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #F7F7F7;
        box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    }


    .image-box.style12 .details {
        padding-top: 0px;
    }


    .booking-section {
        /* border: 1px solid lightgrey; */
            box-shadow: 0 1px 4px 0 rgba(0,0,0,.1);
            border-radius: 1.5px;
    }


    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h2 {
            font-size: 1.3333em;
        }
        h3 {
            font-size: 1.3333em;
        }
        .toggle-container .panel h2.panel-title {
            font-size: 1.3333em;
        }

        .booking-section {
            padding: 20px 10px;
        }


        .toggle-container .panel.style2 .panel-content {
            padding-top: 0px;
            padding-right: 0px;
            padding-bottom: 30px;
            padding-left: 0px;
        }

    }




    /* No Icon on Alert */
    .alert.alert-help:before {
        content: "";
    }
    .alert:before {
        border: 0px;
        left: 0px;

    }
    .alert {
        margin-bottom: 5px;
        padding-left: 10px;

    }


    .alert.alert-help {
        background: #dcecf6;
        color: #406f8c;
    }
    .alert .close,
    .info-box .close {
        color: #406f8c;
    }



    button[disabled], html input[disabled] {
        cursor: default;
        opacity: .6;
        color: green;
    }



    input.input-text, textarea, span.custom-select-services {
        padding-left: 8px;
    }




</style>


// WEBPACK FOOTER //
// src/components/booking/passengers/Passenger.vue